import { useEffect, useRef, useState } from "react";
import { Center, Card, Alert, Button, Stack, Loader, Text } from "@mantine/core";
import { useNavigate, useSearchParams } from "react-router";
import { completeOAuthLogin, AdminApiError, beginOAuthLogin } from "../api.ts";

export function OAuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  // OAuth code 一次性：StrictMode 双调用 effect / 组件重渲染都只允许兑换一次，
  // 否则第二次请求会因 code 已被消费而报 invalid_grant（重放）。
  const exchangedRef = useRef(false);

  useEffect(() => {
    const code = params.get("code");
    const state = params.get("state");
    if (code === null || state === null) {
      setError("OAuth 回调缺少 code/state 参数");
      return;
    }
    if (exchangedRef.current) return;
    exchangedRef.current = true;
    void (async () => {
      try {
        const out = await completeOAuthLogin(code, state);
        void navigate(out.redirectTo, { replace: true });
      } catch (e) {
        const err = e as AdminApiError;
        setError(`${err.code}: ${err.message}`);
      }
    })();
  }, [params, navigate]);

  if (error !== null) {
    return (
      <Center style={{ minHeight: "100vh" }}>
        <Card shadow="sm" padding="lg" radius="md" withBorder style={{ width: 480 }}>
          <Stack gap="md">
            <Text fw={600} size="lg">
              OAuth 回调失败
            </Text>
            <Alert color="red" title="错误">
              {error}
            </Alert>
            <Button onClick={() => void beginOAuthLogin("/", "OAuthCallback.retry")}>
              重新发起登录
            </Button>
          </Stack>
        </Card>
      </Center>
    );
  }
  return (
    <Center style={{ minHeight: "100vh" }}>
      <Stack align="center" gap="sm">
        <Loader size="lg" />
        <Text c="dimmed">正在完成 OAuth 登录...</Text>
      </Stack>
    </Center>
  );
}
